import { render, staticRenderFns } from "./QR.vue?vue&type=template&id=6830ecb6&scoped=true&"
import script from "./QR.vue?vue&type=script&lang=js&"
export * from "./QR.vue?vue&type=script&lang=js&"
import style0 from "./QR.vue?vue&type=style&index=0&id=6830ecb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6830ecb6",
  null
  
)

export default component.exports